import Count from '@/components/ui/Count.tsx'
import { NavigationButtonT } from '@/components/common/menu/NavigationGroupItemButton.tsx'
import { NavigationItemT } from '@/lib/types/navigationTypes.ts'
import { ChevronRight } from 'lucide-react'
import NavDesktopQueueCountBtn from '@/components/common/menu/NavDesktopQueueCountBtn.tsx'

type PropsT = {
  item: NavigationButtonT | NavigationItemT
  isQueue?: boolean
}

export default function NavigationGroupItemContent({ item, isQueue }: PropsT) {
  const showCount = item?.notifications && item.notifications > 0

  return (
    <div
      className={`flex h-9 w-full items-center justify-start gap-2 rounded-md px-2 text-sm text-accent-foreground hover:bg-accent`}
    >
      <span className={`flex h-5 shrink-0 items-center`}>{item.icon}</span>
      <span className={`truncate text-left align-top leading-9`}>{item.name}</span>
      {!!showCount && (
        <span className={`ml-auto flex h-5 items-center`}>
          {!isQueue && <Count quantity={item.notifications as number} />}
        </span>
      )}
      {isQueue && <NavDesktopQueueCountBtn />}

      {item.showArrowRight && (
        <span className={`ml-auto flex h-5 items-center`}>
          <ChevronRight className={`size-4`} />
        </span>
      )}
    </div>
  )
}
